// extracted by mini-css-extract-plugin
export var carrierIcon = "_xn-0";
export var carrierLogo = "_xn-1";
export var detailsSection = "_xn-2";